/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Copilot_Enable_DescInputs */



/**
* | output |
* | --- |
* | "This takes effect immediately and is billed from now." |
*
* @param {Partner_Manage_Copilot_Enable_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_copilot_enable_desc = /** @type {((inputs?: Partner_Manage_Copilot_Enable_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Copilot_Enable_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dies wird sofort wirksam und ab sofort abgerechnet.")
	return /** @type {LocalizedString} */ ("This takes effect immediately and is billed from now.")
});